type KlydoLoopUrlProps =
  | { photoUrl: string | undefined; loopUrl?: never }
  | { loopUrl: string | undefined; photoUrl?: never };

const KlydoLoopUrl = ({ loopUrl, photoUrl }: KlydoLoopUrlProps) => {
  if (photoUrl) {
    return (
      <img
        loading="lazy"
        src={photoUrl}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
        }}
      />
    );
  } else if (loopUrl) {
    return (
      <video
        muted={true}
        src={loopUrl}
        style={{
          width: '100%',
          height: '100%',
          borderRadius: '50%',
          objectFit: 'cover',
        }}
        autoPlay
        loop
        playsInline
      />
    );
  }
  return null;
};
export default KlydoLoopUrl;
